export type AdminLoanOrGroupBrief = Partial<AdminLoanProductBrief | AdminLoanGroupBrief>;
export interface AdminLoanGroupBrief {
  loanProducts: AdminLoanProductBrief[];
  hideInUI?: boolean;
  isActive?: boolean;
  groupIcon?: string;
  loanGroup: string;
  displayName: string;
  groupId: string;
  groupStatus?: string;
  sequence?: number;
}

export class OLALoanDetail {
  loanPurposeType: OLADropdown = new OLADropdown();
  transactionType: OLADropdown = new OLADropdown();
  loanRequestType: OLADropdown = new OLADropdown();
  cardType: OLADropdown = new OLADropdown();
  vehicleCondition: OLADropdown = new OLADropdown();
  propertyType: OLADropdown = new OLADropdown();
  propertyUse: OLADropdown = new OLADropdown();
}

export class OLADropdown {
  isVisible = false;
  isRequired = false;
  defaultValue = '';
  pickList: PickList[] = [new PickList()];
}

export class PickList {
  id?: number;
  value = '';
  label = '';
}

export interface AdminLoanProductBrief {
  isActive: boolean;
  isHideLoanProductSelection?: boolean;
  tag: string;
  publishedDate?: string;
  lastModifiedDate: string;
  deactivatedDate?: string;
  lastSetupStage: string;
  actionMode: string;
  lenderLoanProduct: string;
  identificationTypes: number;
  disclosures: number;
  loanProtectionOptions: number;
  description?: string;
  displayName: string;
  productId: string;
  groupStatus?: string;
  sequence?: number;
}
export class LoanProductGroup {
  public groupId: string;
  public groupName?: string;
  public loanGroup: string;
  public displayName: string;
  public groupIcon?: string;
  public isLoanGroupHasProduct: boolean;
  public loanProducts: LoanProduct[];
  public groupStatus?: string;
  public sequence?: number;
  public isActive?: boolean;
  public hideInUI?: boolean;
}

export class LoanProduct {
  public sequence?: number;
  public productId: string;
  public displayName: string;
  public productName: string;
  public description: string;
  public collateralType: string;
  public min: string;
  public max: string;
  public isSelectedRange: boolean;
  public requestAmountRanges: RequestAmountRange[];
  public loanProtectionOptions: string[];
  public disclosures: ProductDisclosure[];
  public olaLoanDetail: OLALoanDetail;
  public lenderLoanProduct: string;
  public docRefIds: string[];
  public isActive: boolean;
  public actionMode?: string;
  public tag?: string;
  public additionalQuestions?: SortableModel[];
  public additionalQuestionsNotRequired?: boolean;
  public identificationTypes?: APIdentificationTypes[];
  public employmentStatus?: APEmploymentStatuses[];
}

export class RequestAmountRange {
  public amountMin: string;
  public amountMax: string;
  public termMin: string;
  public termMax: string;
  public rangeValues: string[];
}

export class ProductDisclosure {
  public disclosureId: string;
  public sequenceNo: number;
  public isSelected: boolean;
  public isActive: boolean;
  public rangeValues: string[];
}

export class OLACollateralValuation {
  public new: string[];
  public used: string[];
}

export class OLASetting {
  public canShowApplicationExperience: boolean;
  public canShowPostApp: boolean;
  public canShowDocManagement: boolean;
  public canShowDynamicApp: boolean;
  public canShoweSign: boolean;
  public canShowFundingForPersonalLoan: boolean;
  public canShowInstatouch: boolean;
  public new: NewCollateralValuation;
  public used: UsedCollateralValuation;
}

export class NewCollateralValuation {
  public msrp: boolean;
  public invoice: boolean;
}

export class UsedCollateralValuation {
  public nada: boolean;
  public kbb: boolean;
}

export class SortableModel {
  public guid: string;
  public id?: string;
  public name: string;
  public type: string;
  public hide: boolean;
  public order?: number;
  public isRequired?: boolean;
  public maxLength?: number;
  public nameFromArcOs?: string;
}

export class DisableHtmlElements {
  public title: string;
  public noRecords: string;
  public disableTraceElement: boolean;
  public disableSortingElement: boolean;
  public disableAddNewOption: boolean;
  public enableEyeElement: boolean;
}

export class APIdentificationTypes {
  public name: string;
  public id: number;
  public isActive: boolean;
  public isSelected: boolean;
  public isDirty?: boolean;
}

export class IdentificationTypes {
  type: string;
  id: number;
  items: APIdentificationTypes[];
}

export class APEmploymentStatuses {
  public name: string;
  public id: number;
  public isActive: boolean;
  public isSelected: boolean;
}

export class EmploymentStatuses {
  type: string;
  id: number;
  items: APEmploymentStatuses[];
}
